import { render, staticRenderFns } from "./RegistDone.vue?vue&type=template&id=31ff3cea&"
import script from "./RegistDone.vue?vue&type=script&lang=js&"
export * from "./RegistDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports